var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVenmoIcon = function SvgVenmoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 486.667,
    height: 532,
    viewBox: "0 0 381 413"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 14,
    d: "M291.7 23.5c-35.7 8.9-65 16.5-65.2 16.7-.3.2 1.6 5.4 4.1 11.5 17.7 43.7 14.5 83.9-12.3 151.8-11.6 29.5-40.8 87.1-43.7 86.2-.8-.3-15.3-113.3-31.8-247.5l-2.2-18.4-5.1.7C98.9 28.9 9.4 40.3 9.1 40.6c-.3.2 6.2 49.1 14.3 108.7 8.1 59.5 19.2 141 24.7 181 5.4 40 9.9 73.5 9.9 74.3 0 1.2 12.3 1.4 91.8 1.4l91.7-.1 6.5-8.7c71-95.7 119.2-202.9 124.8-277.2 2-27.2-.3-67.5-4.8-85.4-3.1-12-9.3-27.7-10.8-27.5-.4 0-29.9 7.4-65.5 16.4z"
  })));
};
export default SvgVenmoIcon;